export default {
    install(app) {
        app.config.globalProperties.$loader = {
            loader: null,
            show: () => {
                this.loader = app.config.globalProperties.$loading.show({
                    color: '#235273',
                    backgroundColor: '#ffffff',
                    width: 64, height: 64, zIndex: 99,
                });

                return this.loader;
            },
            hide: () => this.loader.hide()
        }
    }
}